var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagonalHatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_l3s9",
    patternUnits: "userSpaceOnUse",
    width: 9.5,
    height: 9.5,
    patternTransform: "rotate(30)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y: 0,
    x2: 0,
    y2: 9.5,
    stroke: "#000000",
    strokeWidth: 7
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#pattern_l3s9)",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalHatching);
export default __webpack_public_path__ + "static/media/diagonal-hatching.ea7c1b7f3bec4c4ee4e3cf9b2128551c.svg";
export { ForwardRef as ReactComponent };